import { getStorage, setStorage, removeStorage } from "./common"

export const TokenName = "token";

export const setToken = (val) => setStorage(TokenName, val);

export const getToken = () => getStorage(TokenName);

export const deleteToken = () => removeStorage(TokenName);